var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FULFILLMENT_TYPE } from '../../constants/status';
import { isCashNCarryOrder } from '../../components/shared/order-number-formatter/OrderNumberFormatter';
import { getOrderStatus } from '../../components/order-details/util/FulfillmentStatus';
var buildOrderLevelLineItemsSessionObj = function (fulfillmentGroups, allowUndelivered) {
    var lineItems = fulfillmentGroups.flatMap(function (group) { return group.lineItems || []; });
    return lineItems.map(function (lineItem) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            lineId: lineItem.lineId || '',
            omsId: lineItem.omsId,
            secOmsId: lineItem.secOmsId,
            relationType: (_a = lineItem.parentLine) === null || _a === void 0 ? void 0 : _a.relationType,
            chargeIdentifier: lineItem.chargeIdentifier,
            skuNumber: lineItem.skuNumber,
            imageUrl: lineItem.imageUrl,
            brandName: lineItem.brandName,
            description: lineItem.description,
            originalOrderedQuantity: (_b = lineItem.originalOrderedQuantity) !== null && _b !== void 0 ? _b : lineItem === null || lineItem === void 0 ? void 0 : lineItem.orginalOrderedQuantity,
            currentQuantity: lineItem.currentQuantity,
            unitPrice: lineItem.unitPrice || 0,
            unitCost: lineItem.unitCost,
            totalPrice: lineItem.totalPrice,
            departmentNumber: lineItem.departmentNumber || 0,
            classId: lineItem.classId || 0,
            subClassId: lineItem.subClassId || 0,
            upcCode: lineItem.upcCode,
            itemWeight: lineItem.itemWeight || 0,
            PONumber: lineItem.PONumber,
            vendorNumber: lineItem.vendorNumber,
            isDFCSourced: lineItem.isDFCSourced,
            vendorName: lineItem.vendorName,
            vendorPartNumber: lineItem.vendorPartNumber,
            fulfillmentVendorNumber: lineItem.fulfillmentVendorNumber,
            returnOnlineAllowed: (_c = lineItem.actions) === null || _c === void 0 ? void 0 : _c.returnOnlineAllowed,
            returnDropoffAllowed: (_d = lineItem.actions) === null || _d === void 0 ? void 0 : _d.returnDropoffAllowed,
            returnInStoreAllowed: (_e = lineItem.actions) === null || _e === void 0 ? void 0 : _e.returnInStoreAllowed,
            returnLORPAllowed: (_f = lineItem.actions) === null || _f === void 0 ? void 0 : _f.returnLORPAllowed,
            productType: lineItem.productType,
            returnWindowEndDate: lineItem.returnWindowEndDate,
            isStatusDeliveredOrOrderPickedup: allowUndelivered
                ? true
                : getOrderStatus((lineItem === null || lineItem === void 0 ? void 0 : lineItem.statusCode) || 101)
                    .isStatusDeliveredOrOrderPickedup,
            customBlindProductType: lineItem.customBlindProductType,
            scac: lineItem.scac,
            shippingCharge: lineItem.shippingCharge,
        });
    });
};
var buildShippingDictionary = function (fulfillmentGroups) {
    var shippingAddresses = {};
    fulfillmentGroups.forEach(function (group) {
        var _a;
        (_a = group.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            var _a;
            if (item.lineId) {
                shippingAddresses[item.lineId] = {
                    shippingAddress: (_a = group.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.deliveryAddress,
                    fulfillmentType: group.fulfillmentType,
                };
            }
        });
    });
    return shippingAddresses;
};
/**
 * Takes OMS response to map fields to sessionStorage for later API use
 * @param orderDetailsData original OMS response
 * @param fulfillmentGroup list of items ordered for this fulfillment, only items for this fulfillment should be stored in session for return process, not all the items within the order
 */
export var buildOrderDetailsV2SessionObj = function (orderDetailsData, allowUndelivered, isCashNCarryOrderNumber) {
    var _a, _b, _c, _d, _e, _f;
    if (isCashNCarryOrderNumber === void 0) { isCashNCarryOrderNumber = false; }
    return ({
        storeNumber: (_a = orderDetailsData.storeNumber) !== null && _a !== void 0 ? _a : 0,
        orderNumber: orderDetailsData.orderNumber || '',
        grandTotalAmount: orderDetailsData.grandTotalAmount,
        subTotalAmount: orderDetailsData.subTotalAmount,
        shippingCharge: orderDetailsData.shippingCharge,
        deliveryCharge: orderDetailsData.deliveryCharge,
        emailId: orderDetailsData.emailId,
        tenders: orderDetailsData.tenders,
        createDateTime: orderDetailsData.createDateTime,
        lineItems: buildOrderLevelLineItemsSessionObj(orderDetailsData.fulfillmentGroups, allowUndelivered),
        chargeTransactions: (_b = orderDetailsData.chargeTransactions) !== null && _b !== void 0 ? _b : [],
        billingAddress: orderDetailsData.billingAddress,
        versionId: orderDetailsData.versionId,
        fulfillmentGroups: orderDetailsData.fulfillmentGroups,
        deliveryDictionary: buildShippingDictionary(orderDetailsData.fulfillmentGroups),
        paymentMethods: orderDetailsData.paymentMethods,
        net: orderDetailsData.net,
        isInStoreOrder: isCashNCarryOrder(orderDetailsData.orderNumber, orderDetailsData.orderOrigin),
        returnOnlineAllowed: (_c = orderDetailsData.actions) === null || _c === void 0 ? void 0 : _c.returnOnlineAllowed,
        returnDropoffAllowed: (_d = orderDetailsData.actions) === null || _d === void 0 ? void 0 : _d.returnDropoffAllowed,
        returnInStoreAllowed: (_e = orderDetailsData.actions) === null || _e === void 0 ? void 0 : _e.returnInStoreAllowed,
        returnLORPAllowed: (_f = orderDetailsData.actions) === null || _f === void 0 ? void 0 : _f.returnLORPAllowed,
        orderShipmentsInfo: createShippingsMap(orderDetailsData),
        isCashNCarryOrderNumber: isCashNCarryOrderNumber,
    });
};
/**
 * Safely checks both the Legacy Nested Error code and the new Generic Error code and returns the error code.
 * @param error - The Axios error object.
 * @returns Returns the object inside the error (code, description and retryable) If none found, will return undefined
 */
export var getAPIErrorData = function (error) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var errorData = ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) ||
        ((_j = (_h = (_g = (_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.returnService) === null || _f === void 0 ? void 0 : _f.errorData) === null || _g === void 0 ? void 0 : _g.errors) === null || _h === void 0 ? void 0 : _h.error) === null || _j === void 0 ? void 0 : _j[0]) ||
        ((_m = (_l = (_k = error === null || error === void 0 ? void 0 : error.response) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.error) === null || _m === void 0 ? void 0 : _m[0]) ||
        undefined;
    return errorData;
};
export var buildSorisOrderLineList = function (lineItems) {
    if (lineItems === void 0) { lineItems = []; }
    return lineItems.map(function (lineItem) {
        var _a;
        return ({
            lineItemId: lineItem.lineId || '',
            quantity: ((_a = lineItem.currentQuantity) === null || _a === void 0 ? void 0 : _a.toString()) || '',
            channelIdentifier: lineItem.channelIdentifier || '',
        });
    });
};
export var buildReturnLabelRequest = function (orderId, emailId, trackingNumbers, isGuest, net) {
    return {
        PrintReturnShippingLabelRequest: {
            EmailId: emailId,
            OrderId: orderId,
            TrackingNumbers: trackingNumbers,
        },
        emailId: emailId,
        orderId: orderId,
        isGuest: isGuest,
        net: net || '',
        trackingNumbers: trackingNumbers,
    };
};
export var retrieveTrackingNumbers = function (fg) {
    var _a;
    // Take all unique tracking numbers from every lineItems's returnOrderTrackingInfo list in the fulfillment group
    var trackingNumbersSet = new Set();
    (_a = fg === null || fg === void 0 ? void 0 : fg.lineItems) === null || _a === void 0 ? void 0 : _a.forEach(function (lineItem) {
        var _a;
        (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.returnOrderTrackingInfo) === null || _a === void 0 ? void 0 : _a.forEach(function (trackingInfo) {
            trackingNumbersSet.add(trackingInfo.TrackingNumber);
        });
    });
    // Simplifying trackingNumbers interface from IHDTrackingInfo[] to string[]
    //  since we only need the tracking number for now
    return Array.from(trackingNumbersSet);
};
/**
 * Returns a string with either 'nex' or 'aafes' depending on the order's militaryExchange, empty otherwise
 *  */
export var getMilitaryExchange = function (orderDetailsData) {
    if (orderDetailsData.isNEXOrder)
        return 'nex';
    if (orderDetailsData.isAAFESOrder)
        return 'aafes';
    return '';
};
/**
 * will generate a mapping that will be used to determine if # of boxes shipped are known
 * currently only supported by DFC orders
 * @param orderDetailsV2 orders object
 * @returns lineId key -> FG.shippingAndHandling.shipments.shipment mapping
 */
export var createShippingsMap = function (orderDetailsData) {
    var _a;
    var shipmentsArray = [];
    var itemShipmentsDictionary = {};
    (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.forEach(function (fg) {
        var _a, _b, _c;
        // add fg shipments to the array
        shipmentsArray.push({
            shipment: (_b = (_a = fg.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.shipments) === null || _b === void 0 ? void 0 : _b.shipment,
            isShippedBoxesKnown: fg.isShippedBoxesKnown,
        });
        (_c = fg.lineItems) === null || _c === void 0 ? void 0 : _c.forEach(function (item) {
            var itemId = item.lineId;
            if (!itemId)
                return;
            // add itemId to shipment mapping
            itemShipmentsDictionary[itemId] = (shipmentsArray.length - 1).toString();
        });
    });
    return {
        shipmentsArray: shipmentsArray,
        itemShipmentsDictionary: itemShipmentsDictionary,
    };
};
export var getTransactionType = function (urlParameter, orderDetailsData) {
    if (urlParameter && urlParameter !== 'undefined') {
        return String(urlParameter);
    }
    if ((orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.statusDescription) === 'Returned')
        return 'R';
    return 'S';
};
export var buildOrderDetailsPath = function (orderDetailsData, receiptOrderNumber) {
    var orderNumber = orderDetailsData.orderNumber, salesDate = orderDetailsData.salesDate, storeNumber = orderDetailsData.storeNumber, transactionId = orderDetailsData.transactionId, registerNumber = orderDetailsData.registerNumber, orderIndex = orderDetailsData.orderIndex;
    return "/myaccount/order-details?orderNumber=".concat(receiptOrderNumber || orderNumber, "&salesDate=").concat(salesDate, "&storeNumber=").concat(storeNumber, "&transactionId=").concat(transactionId, "&registerNumber=").concat(registerNumber, "&index=").concat(orderIndex);
};
// Checks to see if there are any failed STH delivery tracker calls
export var hasFailedSTHDeliveryTracker = function (fulfillmentGroups) {
    return fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.some(function (fg) {
        return fg.fulfillmentType === FULFILLMENT_TYPE.STH &&
            fg.deliveryTrackerData === null;
    });
};
// Helper function to see if any fulfillment group is eligible for returns
export var hasEligibleFGs = function (fgs) {
    return fgs.some(function (fg) {
        var _a, _b, _c;
        return ((_a = fg.actions) === null || _a === void 0 ? void 0 : _a.returnOnlineAllowed) ||
            ((_b = fg.actions) === null || _b === void 0 ? void 0 : _b.returnInStoreAllowed) ||
            ((_c = fg.actions) === null || _c === void 0 ? void 0 : _c.returnLORPAllowed);
    });
};
/**
 * Separates STH and non-STH fulfillment groups and performs delivery tracker crosscheck for STH groups.
 *
 * This function processes fulfillment groups by:
 * 1. Separating STH fulfillment groups from non-STH fulfillment groups
 * 2. For STH groups: crosschecking OMS eligibility flags with delivery tracker eligibility flags using logical AND
 * 3. For non-STH groups: returning them unchanged (no delivery tracker crosscheck needed)
 *
 * The crosscheck ensures that for STH fulfillment groups, both OMS and delivery tracker must allow
 * a return type for it to be considered eligible. This prevents returns when delivery tracker
 * indicates issues with the shipment.
 *
 * @param fulfillmentGroups - Array of fulfillment groups from order details response
 * @returns Object containing:
 *   - updatedSthFGs: STH fulfillment groups with crosschecked eligibility flags
 *   - nonSthFGs: Non-STH fulfillment groups (unchanged)
 *
 * @example
 * ```typescript
 * const { updatedSthFGs, nonSthFGs } = separateAndCrosscheckSTHFGs(orderData.fulfillmentGroups);
 * const allEligibleFGs = [...updatedSthFGs, ...nonSthFGs];
 * const hasEligibleReturns = hasEligibleFGs(allEligibleFGs);
 * ```
 */
export var separateAndCrosscheckSTHFGs = function (fulfillmentGroups) {
    if (fulfillmentGroups === void 0) { fulfillmentGroups = []; }
    var _a = fulfillmentGroups.reduce(function (acc, fg) {
        if (fg.fulfillmentType === FULFILLMENT_TYPE.STH) {
            acc.sthFGs.push(fg);
        }
        else {
            acc.nonSthFGs.push(fg);
        }
        return acc;
    }, { sthFGs: [], nonSthFGs: [] }), sthFGs = _a.sthFGs, nonSthFGs = _a.nonSthFGs;
    // Updated STH fulfillment group eligibilities by crosschecking with delivery tracker eligibility
    var updatedSthFGs = sthFGs.map(function (fg) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var deliveryTrackerData = fg.deliveryTrackerData;
        return __assign(__assign({}, fg), { actions: __assign(__assign({}, fg.actions), { returnOnlineAllowed: ((_b = (_a = fg.actions) === null || _a === void 0 ? void 0 : _a.returnOnlineAllowed) !== null && _b !== void 0 ? _b : false) &&
                    ((_d = (_c = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.actions) === null || _c === void 0 ? void 0 : _c.returnOnlineAllowed) !== null && _d !== void 0 ? _d : false), returnInStoreAllowed: ((_f = (_e = fg.actions) === null || _e === void 0 ? void 0 : _e.returnInStoreAllowed) !== null && _f !== void 0 ? _f : false) &&
                    ((_h = (_g = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.actions) === null || _g === void 0 ? void 0 : _g.returnInStoreAllowed) !== null && _h !== void 0 ? _h : false), returnLORPAllowed: ((_k = (_j = fg.actions) === null || _j === void 0 ? void 0 : _j.returnLORPAllowed) !== null && _k !== void 0 ? _k : false) &&
                    ((_m = (_l = deliveryTrackerData === null || deliveryTrackerData === void 0 ? void 0 : deliveryTrackerData.actions) === null || _l === void 0 ? void 0 : _l.returnLORPAllowed) !== null && _m !== void 0 ? _m : false) }) });
    });
    return { updatedSthFGs: updatedSthFGs, nonSthFGs: nonSthFGs };
};
